import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const LEVEL_DATA = {
  Daylight: {
    icon: '/icons/icon_daylight.png',
    messageKey: 'elevation.daylightMessage',
    color: theme.colors.brandYellow
  },
  Sunshield: {
    icon: '/icons/icon_sunshield.png',
    messageKey: 'elevation.sunshieldMessage',
    color: '#6B48FF'
  }
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Modal = styled.div`
  background-color: ${theme.colors.white};
  border-radius: 20px;
  padding: 40px 30px;
  max-width: 340px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease-in-out;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const IconImage = styled.img`
  width: 72px;
  height: 72px;
  margin-bottom: 12px;
`;

const Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${props => props.color};
  margin-bottom: 8px;
`;

const Title = styled.h2`
  font-family: ${theme.typography.headingFont};
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.deepNavy};
  margin: 0 0 12px;
`;

const CauseName = styled.div`
  font-family: ${theme.typography.bodyFont};
  font-size: 13px;
  color: ${theme.colors.slateGray};
  margin-bottom: 16px;
`;

const Message = styled.p`
  font-family: ${theme.typography.bodyFont};
  font-size: 15px;
  color: ${theme.colors.slateGray};
  line-height: 1.5;
  margin: 0 0 28px;
`;

const DismissButton = styled.button`
  background: ${props => props.color};
  color: ${props => props.color === theme.colors.brandYellow ? theme.colors.deepNavy : 'white'};
  border: none;
  border-radius: 12px;
  padding: 14px 32px;
  font-family: ${theme.typography.bodyFont};
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ElevationCelebrationModal = ({ toLevel, causeName, onClose }) => {
  const { t } = useTranslation();
  const data = LEVEL_DATA[toLevel];
  if (!data) return null;

  return (
    <Overlay onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <IconImage src={data.icon} alt={toLevel} />
        <Eyebrow color={data.color}>{t('elevation.levelElevated')}</Eyebrow>
        <Title>{t('elevation.welcomeTo', { level: toLevel })}</Title>
        <CauseName>{causeName}</CauseName>
        <Message>{t(data.messageKey)}</Message>
        <DismissButton color={data.color} onClick={onClose}>
          {t('elevation.imReady')}
        </DismissButton>
      </Modal>
    </Overlay>
  );
};

export default ElevationCelebrationModal;
